import React, { useState } from "react";
import { Link } from "react-router-dom";
import CONFIG from '../../../config';
import { useParams } from "react-router";
import * as axios from "axios";
import { getAuthHeader } from "../../../utils";
import Swal from 'sweetalert2';
import { token } from '../../Actions/AuthAction';

const Addcourse = (props) => {

  const skillcode = useParams().id;
  var datas = skillcode != undefined ? props.history.location.state.detail : "";

  const [coursename, SetCourseName] = useState(datas ? datas.name : "");
  const [coursestatus, SetCourseStatus] = useState(datas ? datas.status : 1);
  const [id, SetSkillid] = useState(datas ? datas.id : 0);

  const AddCourseName = (e) => {
    e.preventDefault();
    if (skillcode > 0) {
      var jsonToPost = {
        "loginusertoken": token(),
        "name": coursename,
        "status": coursestatus,
        "id": id
      }
    } else {
      var jsonToPost = {
        "loginusertoken": token(),
        "name": coursename,
        "status": coursestatus
      }
    }
    AddCourseAPI(jsonToPost).then((res) => {
      if (coursename != "") {
        if (res.status) {
          let result = Swal.fire({
            icon: "success",
            title: 'Done',
            text: id > 0 ? 'Course updated sussecfully.' : 'Course added sussecfully.'
          }).then(function () {
            window.location = "/mastercourseslist";
          });
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
            footer: res.message
          })
        }

      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Please enter course name',
          footer: res.message
        })
      }
    })
  }

  const AddCourseAPI = (model) => {
    const url = `${CONFIG.BASE_URL}/master/add-course`;
    return axios.post(url, model, getAuthHeader()).then((response) => {
      return response.data;
    });
  };
  return (
    <>
      <div className="row mb-4">
        <div className="col-md-12">
          <h4 className="table_heading position-relative">{skillcode == undefined ? "ADD" : "EDIT"} COURSE</h4>
        </div>
      </div>
      <div className="card table_card mb-4">
        <div className="card-body">
          <form onSubmit={AddCourseName}>
            <div className="row">
              <div class="form-group col-md-12">
                <label class="small mb-1" for="inputPassword">Course Name <span class="text-danger font-weight-bold">*</span></label>
                <div>
                  <input type="text" class="form-control py-4 rounded-pill" placeholder="Enter Name" name="name" value={coursename} onChange={(e) => SetCourseName(e.target.value)} />
                </div>
              </div>
              <div class="form-group col-md-12">
                <label class="small mb-1"> </label>
                <div>
                  <button className="btn btn-primary-custom">Submit</button>
                  <Link to="/mastercourseslist" className="btn btn-secondary-custom mx-2">Cancel</Link>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  )
};

export default Addcourse;
